export default __webpack_public_path__ + "media/zurb/img/ecommerce/bn_1-2da72205ff833bfb98ca6af39c2564d0.png";